import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandlerService } from '@manager-app/service/error-handler.service';
import {
  DateRange,
  extractDateRange,
  extractDefaultStoreIds,
  extractNumberArr,
  FeedbackStoreRankingModel,
  FeedbackTypeRankingModel,
  HxReportService,
  HxUiLabelPipe,
  isoDate,
  toRouterQueryParams
} from 'hx-services';
import { Subscription } from 'rxjs';
import { HxDateRangeSelectComponent, HxLoaderComponent, HxStoreSelectComponent } from 'hx-component';
import { FormsModule } from '@angular/forms';
import { DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-feedback-rating-report.m-grid__item.m-grid__item--fluid.m-wrapper',
    templateUrl: './feedback-rating-report.component.html',
    styleUrls: ['./feedback-rating-report.component.css'],
    imports: [HxStoreSelectComponent, FormsModule, HxDateRangeSelectComponent, NgIf, NgFor, NgClass, HxLoaderComponent, DatePipe, TranslocoPipe, HxUiLabelPipe]
})
export class FeedbackRatingReportComponent implements OnInit, OnDestroy {
  feedbackStoreRatingList: FeedbackStoreRankingModel[] = [];
  feedbackTypeRatingList: FeedbackTypeRankingModel[] = [];
  params: { date?: DateRange, storeIds?: number[] } = {};
  isLoading = {
    store: false,
    type: false
  };
  private sub: Subscription;

  constructor(
    private reportService: HxReportService,
    private aRoute: ActivatedRoute,
    private router: Router,
    private errorService: ErrorHandlerService,
  ) {
  }

  ngOnInit() {
    this.sub = this.aRoute.queryParamMap.subscribe(paramMap => {
      this.params.date = extractDateRange('date', paramMap) ?? {from: isoDate(Date.now()), to: isoDate(Date.now())};
      this.params.storeIds = extractNumberArr('storeIds', paramMap);
      if (this.params.storeIds.length === 0) {
        this.params.storeIds = extractDefaultStoreIds();
      }
      if (this.params.storeIds.length > 0) {
        this.getStoreRating();
        this.getTypeRating();
      }
    });
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  navigate() {
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }

  private getStoreRating() {
    this.isLoading.store = true;
    this.reportService.getFeedbackStoreRating(this.params).subscribe(response => {
      this.feedbackStoreRatingList = response;
      this.isLoading.store = false;
    }, error => {
      this.isLoading.store = false;
      this.errorService.handler(error);
    });
  }

  private getTypeRating() {
    this.isLoading.type = true;
    this.reportService.getFeedbackTypeRating(this.params).subscribe(response => {
      this.feedbackTypeRatingList = response;
      this.isLoading.type = false;
    }, error => {
      this.isLoading.type = false;
      this.errorService.handler(error);
    });
  }
}
